<template>
  <div>
    <PK10
      v-if="lotteryType === 'pk10'"
      :lottery-type="lotteryType"
    />
    <SSC
      v-if="lotteryType === 'ssc'"
      :lottery-type="lotteryType"
    />
    <KL10
      v-if="lotteryType === 'kl10'"
      :lottery-type="lotteryType"
    />
    <KL8
      v-if="lotteryType === 'kl8'"
      :lottery-type="lotteryType"
    />
  </div>
</template>

<script>
import PK10 from '@/components/web/pages/trend/LuJhuFenSi/PK10'
import SSC from '@/components/web/pages/trend/LuJhuFenSi/SSC'
import KL10 from '@/components/web/pages/trend/LuJhuFenSi/KL10'
import KL8 from '@/components/web/pages/trend/LuJhuFenSi/KL8'

export default {
  name: 'LuZhuFenSi',
  components: {
    PK10,
    SSC,
    KL10,
    KL8
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>
